// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"94d6f783","217":"94d6f783","267":"94d6f783","289":"94d6f783","325":"7603433c","330":"94d6f783","348":"94d6f783","356":"94d6f783","407":"94d6f783","670":"94d6f783","833":"94d6f783","838":"94d6f783"}[chunkId] + ".chunk.css";
};